"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var common_1 = require("docs/common");
var components_1 = require("components");
var description = 'This is how you get Button if you don\'t pass any props. ' +
    'It has a nice elevation and, when hovered, its shadow spreads a little bit.';
var code = "import React from 'react';\nimport { Button } from 'jsc-react-ui';\n\nconst ButtonExample = () => <Button />;";
exports.RawExampleButton = function () { return (React.createElement(common_1.Example, { title: "Raw", description: description, code: code },
    React.createElement(components_1.Button, null))); };
exports.RawExampleButton.displayName = 'RawExampleButton';



//////////////////
// WEBPACK FOOTER
// ./src/docs/pages/ComponentButtonPage/RawExampleButton.tsx
// module id = 634
// module chunks = 0